



















import { defineComponent, computed, reactive, watch } from '@vue/composition-api'
import { PreviewVideoQualityType, PreviewSettings } from '@/types/users'
import { KisweFormField, KisweFormGroup, KisweSelect } from '@/modules/kisweui/components'
import { KisweSelectOption } from '@/modules/kisweui/types'

export default defineComponent({
  name: 'UserPreviewQualitySettings',
  components: {
    KisweFormField,
    KisweFormGroup,
    KisweSelect
  },
  props: {
    previewVideoQuality: {
      type: String as () => PreviewVideoQualityType,
      required: true
    }
  },
  emits: {
    update (_previewSettings: PreviewSettings) { return true }
  },
  setup (props , { emit }) {
    const previewQuality = reactive({
      video: props.previewVideoQuality
    })
    const videoPreviewOptions = computed(() => {
      const options: KisweSelectOption[] = []
      for (const key in PreviewVideoQualityType) {
        const targetKey = key as keyof typeof PreviewVideoQualityType
        options.push({ label: PreviewVideoQualityType[targetKey], value: PreviewVideoQualityType[targetKey] })
      }
      return options
    })

    watch(previewQuality, (newPreviewQuality) => emit('update', newPreviewQuality))

    return {
      previewQuality,
      videoPreviewOptions
    }
  }
})
